import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { TitleChange } from '../services/title-change';
import { Link } from "../directives/link";
import { RouterLink } from "@angular/router";

@Component({
  selector: 'app-pontius-pilate',
  imports: [Link, RouterLink],
  templateUrl: './pontius-pilate.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './pontius-pilate.scss',
})
export class PontiusPilate {
  dynamicTitle = inject(TitleChange);
  
  constructor() {
    this.dynamicTitle.title(`Pontius Pilate`);
    this.dynamicTitle.description(`Pontius Pilate was a Roman prefect there is no evidence outside of the New Testament that confirms his involvement in the events described in the gospels.`);
  }
}
